import { render, staticRenderFns } from "./ConfirmationDelete.vue?vue&type=template&id=3abf60cd&"
import script from "./ConfirmationDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports